import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=946856fa&scoped=true"
import script from "./customDialog.vue?vue&type=script&lang=js"
export * from "./customDialog.vue?vue&type=script&lang=js"
import style0 from "./customDialog.vue?vue&type=style&index=0&id=946856fa&prod&lang=scss"
import style1 from "./customDialog.vue?vue&type=style&index=1&id=946856fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946856fa",
  null
  
)

export default component.exports